import { render, staticRenderFns } from "./DownloadDocuments.vue?vue&type=template&id=39fa9d96&scoped=true&"
import script from "./DownloadDocuments.vue?vue&type=script&lang=js&"
export * from "./DownloadDocuments.vue?vue&type=script&lang=js&"
import style0 from "./DownloadDocuments.vue?vue&type=style&index=0&id=39fa9d96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fa9d96",
  null
  
)

export default component.exports